// <card-video> in product cards (snippets/product-card.liquid, card_video): one card video
// decodes at a time. The first card at least 60% in view plays; every other one is released
// (src removed), so off-screen cards stop downloading too. The poster image shows until it plays.
(function () {
  if (customElements.get('card-video') || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var seen = new Set(), current = null;
  function pick() {
    var next = null;
    seen.forEach(function (el) {
      if (!next || el.compareDocumentPosition(next) & Node.DOCUMENT_POSITION_FOLLOWING) next = el;
    });
    if (next === current) return;
    if (current) current.stop();
    current = next;
    if (current) current.start();
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.intersectionRatio >= 0.6) seen.add(e.target); else seen.delete(e.target);
    });
    pick();
  }, { threshold: [0, 0.6] });
  customElements.define('card-video', class extends HTMLElement {
    connectedCallback() { io.observe(this); }
    // Filtering and paging swap the grid: forget cards that left the page.
    disconnectedCallback() {
      io.unobserve(this);
      seen.delete(this);
      if (current === this) { this.stop(); current = null; pick(); }
    }
    start() {
      var self = this, v = this.querySelector('video');
      v.onplaying = function () { self.classList.add('is-playing'); };
      v.src = this.dataset.src;
      v.play().catch(function () {});
    }
    stop() {
      var v = this.querySelector('video');
      this.classList.remove('is-playing');
      v.pause();
      v.removeAttribute('src');
      v.load();
    }
  });
})();
